<template>
  <v-container>
    <v-row justify-space-around>
      <v-col cols="10" md="6" sm="6" lg="3">
        <v-textarea v-model="message" auto-grow outlined color="primary" label="SMS text" rows="2"></v-textarea>
      </v-col>
      <v-col cols="2">
        <v-btn v-if="this.message" small fab color="primary" dark @click="SendSMS">
          <v-icon dark>mdi-send</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
  <!-- <v-layout ma-4>
    <v-flex xs12 sm6 offset-sm3>
      
    </v-flex>
  </v-layout>-->
</template>
<script>
import axios from "axios";
export default {
  props: ["client"],
  data() {
    return {
      message: null,
      result: ""
    };
  },
  methods: {
    SendSMS() {
      let sendSMS = {
        sendSMS: {
          message: this.message,
          phoneNumber: this.client.phoneNumber
        }
      };
      let mutation = `mutation sendSMS($sendSMS: sendSMS!) {
			                    sendSMS(sendSMS : $sendSMS) {
                                    result
                                    }
                            }`;
      axios
        .post("/graphql", {
          query: mutation,
          variables: sendSMS
        })
        .then(res => {
          if (res.data.data.sendSMS) {
            this.result = res.data.data.sendSMS.result;
            if (this.result == "Success") {
              this.showSuccess("Message sent!");
            }
            this.message = null;
          }
        })
        .catch(() => {
          this.showError("Error occured while sending SMS!");
        });
    }
  }
};
</script>
